// extracted by mini-css-extract-plugin
export const people = "about-people-module--people--DFUFM";
export const contentItem = "about-people-module--content-item--3EHLv";
export const info = "about-people-module--info--3R-us";
export const image = "about-people-module--image--28I6L";